import { Provider } from 'models';

export const WORKED = 'worked';
export const STAFF = 'staff';

export interface IProviderBusinessOutlaw {
    id: number;
    user: number;
    business?: number | null;
    business_location?: number | null;
}

export interface IProviderPreferredWorker {
    id: number;
    user: number;
    business?: number | null;
    business_location?: number | null;
}

export interface IProviderSearch extends Provider {
    type?: string;
    business_outlaws?: IProviderBusinessOutlaw[];
    preferred_workers?: IProviderPreferredWorker[];
}

export interface FilterProps {
    page: number;
    searchQuery?: string;
    workerType: string;
    includeBlocked: boolean;
    showPreferred: boolean;
    address: string;
}
